<template lang="pug">
  lei-popover.container(:text="tooltips.backTo")
    .go-back(@click="returnToSearch")
      i.arrow.el-icon-arrow-left
      a.link Back to search results
</template>
<script>
import LeiPopover from '../../components/lei-components/LeiPopover'
import record from '../../constants/tooltips/record'
import routerSearch from '../../mixins/router-search-mixin'
import { mapMutations, } from 'vuex'
import { CLEAR_CHALLENGE, } from '@/store/modules/record/modules/challenge/mutations-types'
import { EventBus, } from '@/event-bus'

export default {
  components: {
    LeiPopover,
  },
  mixins: [ routerSearch, ],
  data () {
    return {
      tooltips: record,
    }
  },
  methods: {
    returnToSearch () {
      this.clearChallenge()
      EventBus.$emit('challenge-clear')
      this.routerSearch('')
    },

    ...mapMutations('record/challenge', {
      clearChallenge: CLEAR_CHALLENGE,
    }),
  },
}
</script>
<style lang="stylus" scoped>
  @import "../../assets/styles/variables.styl"
  .back-to-search
    width 85%
  .go-back
    margin 0.5rem 0 2rem
    display flex
    align-items center

    &:hover
      cursor pointer

      .link, .arrow
        color $turquoise-color

    .link
      font-size 90%
      font-weight 600
      margin-left 0.3rem
      text-decoration none
      color $default-color-bold
      border-bottom 1px solid $turquoise-color
      padding-bottom 3px

    .arrow
      font-size 200%
      font-weight bold
      color $default-color-middle-1
  @media (max-width: $laptop)
    .go-back
      margin 0
      display flex
      align-items center

</style>



// WEBPACK FOOTER //
// src/components/record-details/BackToSearch.vue